import { useEffect, useState } from "react";
import { MagiClient, TokenRejectedError } from "../api/magi";
import type { AppConfig } from "../config";
import type { TokenInfo } from "../types";

export type TokenCapabilitiesState =
  | { status: "loading" }
  | { status: "ready"; info: TokenInfo }
  | { status: "error"; kind: "unauthorized" | "network"; message: string };

export function useTokenCapabilities(
  config: Pick<AppConfig, "serviceBaseUrl" | "serviceToken">,
): TokenCapabilitiesState {
  const [state, setState] = useState<TokenCapabilitiesState>({
    status: "loading",
  });

  useEffect(() => {
    let cancelled = false;
    setState({ status: "loading" });

    const client = new MagiClient(config);
    client
      .getTokenInfo()
      .then((info) => {
        if (!cancelled) setState({ status: "ready", info });
      })
      .catch((err) => {
        if (cancelled) return;
        if (err instanceof TokenRejectedError) {
          setState({
            status: "error",
            kind: "unauthorized",
            message:
              "Token rejected. Check MAGI_SERVICE_TOKEN — it must be a valid magi_-prefixed service token.",
          });
        } else {
          setState({
            status: "error",
            kind: "network",
            message:
              err instanceof Error ? err.message : "Unable to reach MAGI-Service.",
          });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [config.serviceBaseUrl, config.serviceToken]);

  return state;
}
